import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { MachineService, MachineId } from '../../services/machine.service';
import { CatalogsSettingsService } from '../../services/catalogs-settings.service';
import { PermissionService } from '../../services/permission.service';
import { AuthService } from '../../services/auth.service';
import { Router } from '@angular/router';
import { toast } from 'angular2-materialize';
import { UnitService } from '../../services/unit.service';

@Component({
  selector: 'app-read-machine',
  templateUrl: './read-machine.component.html',
  styleUrls: ['./read-machine.component.css']
})
export class ReadMachineComponent implements OnInit, OnDestroy {
  allowed: boolean = false;
  permission: any = {};
  loading: boolean[] = Array(3).fill(false);
  get loaded(): boolean { return !this.loading.includes(false); }

  machines:any[] = [];
  units: any = {};

	data:Array<any>;
  rows:Array<any> = [];
  columns:Array<any> = [
    {title: 'Folio', name: 'name', sort: 'asc'},
    {title: 'Nombre', name: 'name2'},
    {title: 'Cabezas', name: 'headers'},
    {title: 'Medida', name: 'measure'},
    { title: 'Acciones', className: 'center',  name: 'actionGroup', sort: false, actions: { type: 'group', buttons: [
			{ name: 'edit', title: '', styleIcon: 'edit', action: 'onEdit', styleClass: 'btn-floating btn waves-effect light-green darken-1' },
			{ name: 'delete', title: '', styleIcon: 'delete', action: 'onDelete', styleClass: 'btn-floating btn waves-effect red darken-2', }
		] } }
  ];
  page:number = 1;
  itemsPerPage:number = 5;
  maxSize:number = 5;
  numPages:number = 1;
  length:number = 0;

  config:any = {
    paging: true,
    sorting: {columns: this.columns},
    filtering: {filterString: ''},
		api: {
			onEdit: this.onEdit.bind(this),
			onDelete: this.onDelete.bind(this)
		}
  };

  sub: Subscription;

  constructor(
    private service: MachineService,
    private unitService: UnitService,
    private settings: CatalogsSettingsService,
		private permissionService: PermissionService,
		private authService: AuthService,
    private router: Router
  ) {
    let permissionsSubs = this.permissionService.getUserPermissionByEmail(this.authService.currentUser['email']).subscribe((groups) => {
        permissionsSubs.unsubscribe();
        this.permission = this.permissionService.constructPermissionObject(groups, service.collection);
        if(!this.permission || !this.permission.readAction) toast('Faltan permisos para poder ver.', 5000);
        else this.allowed = true;
    });

    let subSet = this.settings.getPayrollSettings('1').subscribe(setting => {
      subSet.unsubscribe();
      this.itemsPerPage = setting.tableQuantity;
      this.loading[0] = true;
    });

    let unitSub = this.unitService.getUnits().subscribe(units => {
      unitSub.unsubscribe();
      this.units = units.reduce((acc, cur) => ({ [cur.id]: cur.symbol, ...acc }), {});
      this.loading[1] = true;
    });

		this.sub = this.service.getMachines().subscribe(tempMachines => {
			this.machines = tempMachines.map(({name, folio, ...m}: MachineId) => ({
        units: this.units,
        get measure() { return `${m.maxWidth} ${this.units[m.maxWidthUnitId]} x ${m.maxLong} ${this.units[m.maxLongUnitId]}`},
        name: folio,
        name2: name,
        ...m
      }) )
      this.data = this.machines;
			this.length = this.data.length;
      this.onChangeTable(this.config);
      this.loading[2] = true;
    });
    
	}

  ngOnInit() {
  }
  ngOnDestroy(){
    this.sub.unsubscribe();
  }

	onCellClick({row}: {row: MachineId}): any {
    this.service.window.view(row.id);
  }

  onCreate(){
    if(!this.permission.createAction) return toast('No tiene los permisos para crear.', 2000);
    this.service.window.add();
  }

	onEdit({row}: {row: MachineId}) {
    if(!this.permission.updateAction) return toast('No tiene los permisos para editar.', 2000);
    this.service.window.edit(row.id);
	}

	onDelete({row}: {row: MachineId}) {
    if(!this.permission.deleteAction) return toast('No tiene los permisos para eliminar.', 2000);
    this.service.deleteMachine(row.id);
	}

	//*********** Filter, sort, and pagination */

	changePage(page:any, data:Array<any> = this.data):Array<any> {
    let start = (page.page - 1) * page.itemsPerPage;
    let end = page.itemsPerPage > -1 ? (start + page.itemsPerPage) : data.length;
    return data.slice(start, end);
  }

  changeSort(data:any, config:any):any {
    if (!config.sorting) {
      return data;
    }

    let columns = this.config.sorting.columns || [];
    let columnName:string;
    let sort:string;

    for (let i = 0; i < columns.length; i++) {
      if (columns[i].sort !== undefined && columns[i].sort !== '' && columns[i].sort !== false) {
        columnName = columns[i].name;
        sort = columns[i].sort;
      }
    }

    if (!columnName) {
      return data;
    }

    // simple sorting
    return data.sort((previous:any, current:any) => {
      if (previous[columnName] > current[columnName]) {
        return sort === 'desc' ? -1 : 1;
      } else if (previous[columnName] < current[columnName]) {
        return sort === 'asc' ? -1 : 1;
      }
      return 0;
    });
  }

  changeFilter(data:any, config:any):any {
    let filteredData:Array<any> = data;
    this.columns.forEach((column:any) => {
      if (column.filtering) {
        filteredData = filteredData.filter((item:any) => {
          return item[column.name].match(column.filtering.filterString);
        });
      }
    });

    if (!config.filtering) {
      return filteredData;
    }

    if (config.filtering.columnName) {
      return filteredData.filter((item:any) => item[config.filtering.columnName].match(this.config.filtering.filterString));
    }

    let tempArray:Array<any> = [];
    filteredData.forEach((item:any) => {
      let flag = false;
      this.columns.forEach((column:any) => {
        if (item[column.name] && item[column.name].toString().toLowerCase().match(this.config.filtering.filterString.toLowerCase())) {
          flag = true;
        }
      });
      if (flag) {
        tempArray.push(item);
      }
    });
    filteredData = tempArray;

    return filteredData;
  }

  onChangeTable(config:any, page:any = {page: this.page, itemsPerPage: this.itemsPerPage}):any {
    if (config.filtering) {
      Object.assign(this.config.filtering, config.filtering);
    }

    if (config.sorting) {
      Object.assign(this.config.sorting, config.sorting);
    }

    let filteredData = this.changeFilter(this.data, this.config);
    let sortedData = this.changeSort(filteredData, this.config);
    this.rows = page && config.paging ? this.changePage(page, sortedData) : sortedData;
    this.length = sortedData.length;
  }

}
